<template>
  <HoverPopNormal>
    <template #title>
      <span v-bind:class="{ 'primary--text': isPrimaryColor }">{{
        $t('sale.sale_breakdown')
      }}</span>
    </template>
    <v-container fluid class="pa-0">
      <v-row
        no-gutters
        v-for="(rec, index) in currencyAmount"
        :key="index"
        class="rowStyle"
      >
        <v-col>{{ getCurrencyName(rec) }}:</v-col>
        <v-col class="pl-5 text-right">{{ formatAmount(rec.amount) }}</v-col>
      </v-row>
    </v-container>
  </HoverPopNormal>
</template>

<script>
import { currencyUtil, commonUtil } from '@/util'
import HoverPopNormal from './HoverPopNormal'

export default {
  components: {
    HoverPopNormal
  },
  props: {
    currencyAmount: {
      type: Array,
      require: true,
      default: () => []
    },
    isPrimaryColor: { default: false }
  },
  data: () => ({
    //
  }),
  methods: {
    getCurrencyName(rec) {
      const ret = currencyUtil.findCurrencyNameById(rec.currencyId)
      return ret.name
    },
    formatAmount(amount) {
      return commonUtil.formatPrice(amount).toLocaleString()
    }
  }
}
</script>
<style scoped lang="scss">
.rowStyle {
  min-width: 120px;
}
</style>
